import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Grid, Button, IconButton, Badge } from '@material-ui/core';
import _ from 'lodash';
import CloseIcon from '@material-ui/icons/Close';
import {
	WithStyles, createStyles, Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	RemoveRedEye as PreviewIcon,
	FileCopy as CopyIcon,
} from '@material-ui/icons';
import { dateService, MyPATLink } from '../../../common';
import urlService from '../../../common/services/urlService';
import { showMsg } from '../../../course/actions/loaderAlert';
import contentService from '../../services/contentService';
import ContentData, { StepWiseSolution } from '../../types/ContentData';
import { bindActionCreators } from 'redux';
import { getCommentCount } from '../../actions/commentActions';
import CommentDialog from '../ContentPreview/CommentDialog'
import contentActions from '../../actions/contentActions';
import ContentFormData from '../../types/ContentFormData';
import ContentSubtypeData from '../../types/ContentSubtypeData';
import { calCulateProgressBar, isQuestionAddToQueueModeActive, isAddToQueueChangesActiveParagraph, isQuestionAddToQueueModeActiveParagraph, validateQuestionBenchmarks, isConceptAndChapterAddToQueueModeActive, isDifficultyAndSkillAddToQueueModeActive, checkIsCorrectAnswerChangeParagraph } from '../../../../utils';
import { AUTHORING_CONTENT_TYPES, CONTENT_SECTION_TYPES, CONTENT_STATES, CONTENT_TYPE, NOTES_TYPE, OBJECTIVE_NOTES, QUESTION_TYPE, QUESTION_TYPES, SUBJECTIVE_NOTES } from '../../../../constants/comman';
import { element } from 'prop-types';
import { questionActions } from '../../reducers/questionCreateReducer';
import { QuestionBenchmarkItem } from '../../types/Benchmarks';
import { getTimeInSecs } from '../../../../utils/getOffset.utils';
import { AllQuestionBenchmarks } from '../../types/Benchmarks';
import { notePayload, setAddConceptAndChapter,pagesInArrayForm } from '../../helper/notesPayload';
import ForceSaveForChallengePopup from '../ContentPreview/ForceSaveForChallengePopup';
import contentRequestServices from '../../../content-request/services/contentRequestServices';
import { contentRequestAccordianActions } from '../../../content-request/reducers/contentRequestAccordianState';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ACLService from '../../../acl/services/aclService';
import Variation from './Variation';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import { Attachment } from '../../../common/MyPATUploader';
import { FEEDBACK_VALIDATOR_ACTIONS } from '../../helper/contentValidation';

const practiceSetTypeImage: any = {
    "cppSubjective": '/assets/svg/createContent/cppSubjective.svg',
    "cppObjective": '/assets/svg/createContent/cppObjective.svg',
    "workbookSubjective": '/assets/svg/createContent/workbookSubjective.svg',
    'workbookObjective': '/assets/svg/createContent/workbookObjective.svg',
    "assignmentsSubjective":'/assets/svg/createContent/assignmentSubjective.svg',
	'assignmentsObjective': '/assets/svg/createContent/assignmentObjective.svg',
	"archiveSubjective": '/assets/svg/createContent/archiveSubjective.svg',
	"archiveObjective": '/assets/svg/createContent/archiveObjective.svg',
};

const styles = (theme: Theme) =>
	createStyles({
		activeArrow: {
			background: "rgb(29 125 234)",
		},
		deactiveArrow: {
			background: "rgb(29 125 234)",
			opacity: 0.5,
			pointerEvents: "none",
		},
		borderRadius2x: {
			borderRadius: 2,
		},
		toolBox: {
			position: "sticky",
			top: 0,
			zIndex: 99,
			minHeight: "60px",
			lienHeight: "60px",
			background: "#FBFBFB",
			// padding: theme.spacing.unit + 2,
			borderBottom: "1px solid #eee",
			"& .jodit_toolbar": {
				// width: "98vw !important",
				textAlign: 'center',
				marginBottom: "-10px !important",
				marginLeft: '-15px !important',
				marginRight: '0 !important',
			},
			"& .jodit_toolbar_popup":{
				padding: '10px !important',
			},
			"& .arrow": {
				padding: "0px 3px 2px 2px",
				borderRadius: "50%",
				margin: "0px 4px",
				color: "#fff",
				cursor: "pointer",
				"&:hover": {
					background: "rgb(29 125 234)",
				},
			},
			"& .closeButton": {
				color: "#1d7dea",
				cursor: "pointer",
				verticleAlign: "middle",
				"& svg": {
					marginBottom: 2,
				},
			},
		},
		backButton: {
			"&:hover": {
				textDecoration: "none",
			},
			"& svg": {
				marginRight: theme.spacing.unit / 2,
			},
		},
		mb1x: {
			marginBottom: theme.spacing.unit,
		},
		actionContainer: {
			display: "flex",
			alignItems: "center",
			paddingTop: 15,
			paddingRight: 15,
			justifyContent: "flex-end",
			paddingBottom: 15,
			"&>:first-child": {
				"& span": {
					"&>:first-child": {
						padding: "5px 2px 0px 0px",
					},
				},
			},
			"& > *": {
				marginRight: theme.spacing.unit * 1.5,
				"&:last-child": {
					marginRight: 0,
				},
			},
			"& button": {
				"&:nth-of-type(1)": {
					border: "1px solid #dfdfdf",
					"&>span:nth-of-type(1)": {
						"& span": {
							display: "inherit",
							marginRight: "5px",
						},
					},
				},
				"&:nth-of-type(2)": {
					border: "1px solid #dfdfdf",
					"&>span:nth-of-type(1)": {
						"& svg": {
							marginRight: "5px",
						},
					},
				},
			},
		},
		shareIconRoot: {
			transform: "rotateY(180deg)",
		},
		commentButton: {
			"&:hover": {
				backgroundColor: "transparent",
			},
			"& svg": {
				marginRight: 0,
				fontSize: 24,
			},
		},
		primaryColor: {
			color: "#1d7dea",
			fontSize: "1rem",
		},
		displayFlex: {
			display: "flex",
			alignItems: "center",
			justifyContent: "flex-start",
			paddingTop: 5,
			"& img": {
				marginRight: "10px",
			},
		},
		toolbarContainer: {
			"& ul": {
				// width: "100vw !important",
				border: "none !important",
				borderTop: "1px solid #dfdfdf !important",
			},
			'& #box':{
				maxWidth: '100%',
				flexBasis:'100%',
			}
		},
		closeIcon: {
			'&:hover': {
				background: 'none',
			},
			"& svg": {
				fill: "#999",
				transform: "scale(1.4)",
			},
		},
		variationContainer: {
			marginLeft: '20px'
		},
		noteIcon:{
			width:'35px',
			marginRight:'6px !important',
		}
	});

interface HeaderToolProps extends WithStyles<typeof styles> {
	title: string,
	optionsContent: any,
	type: string,
	subType: any,
	subjects: any,
	requestId: string,
	secondarySubjects: any,
	difficultyLevel: any,
	difficultyType: any,
	tags: any,
	notesData: any,
	defaultCorrectAnswersForParagraph: any[],
	correctAnswer: any,
	alternateAnswer: boolean,
	isValidAttempts: boolean,
	defaultCorrectAnswer: any,
	solutionContent: string,
	stepWiseSolution: StepWiseSolution[],
	questionHints: string,
	showMsg: any,
	validations: any,
	content: ContentData,
	formData: ContentFormData,
	originalFormData: ContentFormData,
	refreshContent: Function,
	getCommentCount: (contentId: string) => void,
	commentCount: number,
	history: any,
	match: any,
	editorId: any,
	lockData: any,
	fetchEditLockInfo: Function,
	handleFormSubmit: () => {},
	matrixOptionContent: any,
	setDraftId: Function,
	idealTime: any,
	contentSubtype: {
		list: ContentSubtypeData[],
		question: ContentSubtypeData[],
		testpapers: ContentSubtypeData[],
	},
	allQuestionBenchmarks: AllQuestionBenchmarks,
	updateQuestionBenchmarks: any;
	templateChanged: Function,
	requiresForceSaveForChallenge: boolean;
	setRequiresForceSaveForChallenge: (val: boolean) => void;
	relevantExams: any;
	setPublishedContent: any,
	setAccordingTouchIndex: any,
	accordianCreateTouched: any,
	fromFeedback: boolean,
	currentQuestionNumber: number,
	currentTestNumber: number,
	sliderData: any,
	handleArrowClick: Function,
	prevPath: string,
	addFeedbackActive: Function,
	previewClicked: Function,
	setFeedbackClose: Function,
	saveContent:Function,
	notesPdfAttachment:Attachment[]
}

interface HeaderToolStates {
	isShareDialogOpen: boolean,
	isCommentDialogOpen: boolean,
	eventType: string,
	isForceSaveForChallengeDialogOpen: boolean;
}


class HeaderTool extends Component<HeaderToolProps, HeaderToolStates>{
	constructor(props: HeaderToolProps) {
		super(props);

		this.state = {
			isShareDialogOpen: false,
			isCommentDialogOpen: false,
			eventType: '',
			isForceSaveForChallengeDialogOpen: false
		}

		this.onShared = this.onShared.bind(this);
		this.share = this.share.bind(this);
		this.createClone = this.createClone.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this._handleClose = this._handleClose.bind(this);
		this.previewFromFeedback = this.previewFromFeedback.bind(this);
	}
	previewFromFeedback() {
		if (this.props.previewClicked) {
			this.props.previewClicked()
		}
	}
	componentDidUpdate(prevProps: any) {
		const { content, formData, history } = this.props;
		const { eventType } = this.state
		if (!_.isEmpty(content)) {
			const _id = (formData && formData._id) || content.content_Id
			// _id && this.props.getCommentCount(_id);
		}
		if (this.props.lockData !== prevProps.lockData) {
			if (this.props.lockData.message === 'Success') {
				if (eventType === 'close') {
					this.handleBack()
				} else if (eventType === 'preview') {
					history.push("/content/preview/" + content._id)
				}
			}
		}
	}

	handleCommentDialogClose() {
		this.setState({ isCommentDialogOpen: false })
	}

	share() {
		this.setState({ isShareDialogOpen: true });
	}

	onShared(shared: boolean) {
		this.setState({ isShareDialogOpen: false });
		if (shared && this.props.refreshContent) {
			setTimeout(() => { this.props.refreshContent(); }, 300)
		}
	}

	handleViewChallenges = () => {
		this.setState({
			isForceSaveForChallengeDialogOpen: false
		}, () => {
			this.props.setRequiresForceSaveForChallenge(false);
			this._handleClose();
		})
	}
	handleCloseWithPrevention = () => {
		const { requiresForceSaveForChallenge } = this.props
		if (requiresForceSaveForChallenge) {
			this.setState({
				isForceSaveForChallengeDialogOpen: true
			})

		} else {
			this._handleClose();
		}
	}
	_handleClose() {
		const { content, fetchEditLockInfo, requestId } = this.props;
		if (requestId) {
			const allStates: any = localStorage.getItem('allStates');
			const allStatesData = JSON.parse(allStates);
			const { contentRequestData = {} } = allStatesData;
			const { contentRequestData: { _id: contentRequestId = '' } = {} } = contentRequestData;
			let url = `/contentRequest/owner-task/${contentRequestId}/creator`
			window.location.href = url;
			// contentRequestServices.getOwnerTaskByRole(contentRequestId,role).then((result: any) => {
			// })
		}
		const creatorId = _.get(content, 'content.aclMetaData.createdBy.id');
		let authUser = ACLService.getUserDetailsFromStorage();
		authUser = authUser && authUser.authenticatedUser;
		const isCreatedByLoggedInUser = creatorId && authUser && creatorId === authUser._id;
		if (isCreatedByLoggedInUser && [content.status, content.validationStatus].includes(FEEDBACK_VALIDATOR_ACTIONS.REJECTED)) {
			this.props.history.push('/mylibrary');
		}

		if (content._id) {
			if (content.masterVariationQuestionId) {
				let { contentTypeCode, contentSubTypeCode, masterVariationQuestionData, masterVariationQuestionId } = content
				contentTypeCode = contentTypeCode.toString().trim()
				contentSubTypeCode = contentSubTypeCode == '5' ? contentSubTypeCode.toString().trim() : masterVariationQuestionData.questionCode.toString().trim()
				let url = `/content/edit/${contentTypeCode}/${contentSubTypeCode}/${masterVariationQuestionId}${contentTypeCode}`
				window.location.href = url;
			} else {
				const params = {
					_id: content._id,
				}
				const queryStrings = {
					eventType: 'close'
				}
				const requestObject = {
					params, queryStrings
				}
				this.setState({
					eventType: 'close'
				})
				fetchEditLockInfo(requestObject)
			}
		} else {
			this.handleBack()
		}
		this.props.templateChanged(false)
	}

	handleBack() {
		let { match, history } = this.props;
		let isRef = !_.isEmpty(history.location.search) && history.location.search.search('ref') != -1 ? true : false;
		let isRefUrl = !_.isEmpty(history.location.search) && history.location.search.search('refUrl') != -1 ? true : false;
		const isContentEdit = window.location.href.indexOf('/content/edit/');
		if (isRefUrl) {
			let url = urlService.getParams(history.location.search, 'refUrl');
			window.location.href = url;
		} else {
			if (isRef) {
				history.goBack();
			} else if (isContentEdit > -1) {
				history.push('/content/preview/' + _.get(this.props, "match.params.contentId", ""))
			} else {
				history.push('/mylibrary')
			}
		}

	}

	createClone = () => {
		const { type, subType } = this.props;
		if (this.props.content.contentSubTypeCode === 'note') {
			contentService.clone(this.props.content._id)
				.then((res) => {
					//@ts-ignore
					// TODO - check why histroy.push not working 
					window.location = `/content/edit/studymaterial/notes/${res._id}note`
				})

		}
		else {
			contentService.clone(this.props.content._id)
				.then((res) => {
					if (`${type}_${subType}` === 'studymaterial_videos') {
						res._id && window.open(`/content/edit/studymaterial/videos/${res._id}videos`, '_blank')
					}
					else if(`${type}` === 'question'){
						//@ts-ignore
						window.location = `/content/edit/question/${subType}/` + res._id + res.type
					}
					else if (`${type}_${subType}` === 'studymaterial_audios') {
						res._id && window.open(`/content/edit/studymaterial/audios/${res._id}audios`, '_blank')
					}
					else if (type === 'studymaterial') {
						res._id && window.open(`/content/edit/studymaterial/${subType}/${res._id}${subType}`, '_blank');
					}
					else {
						//@ts-ignore
						// TODO - check why histroy.push not working 
						window.location = `/content/edit/testpapers/${subType || 'sample'}/${res._id}${res.type}`
					}
				})
		}
	}

	handlePreview() {
		const { content, fetchEditLockInfo, history, match } = this.props
		const { params: {
			requestId = ''
		} } = match;
		if (requestId) {
			history.push(`/content/preview/${content._id}/${requestId}`);
		} else {
			if (content._id) {
				const params = {
					_id: content._id,
				}
				const queryStrings = {
					eventType: 'close'
				}
				const requestObject = {
					params, queryStrings
				}
				this.setState({
					eventType: 'preview'
				})
				fetchEditLockInfo(requestObject)
			} else {
				history.push("/content/preview/" + content._id)
			}
		}
	}

	getPageNumber = (key: any): any => {
		const extractNumber = key.replace(/^\D+/g, '');
		return extractNumber;
	}

	validateCustomDescription = (description: any) => {
		const mainContent = description.replace(/(&nbsp;|<([^>]+)>)/ig, '');
		if (mainContent.length > 180) {
			return true;
		}
	}

	saveNotes = async (pages: any) => {
		const { notesData, content,notesPdfAttachment } = this.props;
		const { attempt,activeTab, pdfUrl } = notesData;
		let copyNotesData = setAddConceptAndChapter(notesData);
		if (copyNotesData && copyNotesData.pageError && copyNotesData.pageError.title) {
			this.props.showMsg(copyNotesData.pageError.title, 'error');
		} else {
			delete copyNotesData.pageState;
			delete copyNotesData.pageError;
			delete copyNotesData.attempt;
			delete copyNotesData.activeTab;
			delete copyNotesData.pdfUrl;
			let attachment: any = pdfUrl;
			if(notesPdfAttachment && notesPdfAttachment.length > 0 ) {
			  attachment = notesPdfAttachment
			} 
			const pageKeyName = Object.keys(notesData.pageState);
			const finalPayLoad =activeTab==="Upload PDF"? await notePayload(pages, pageKeyName, attempt,attachment): await notePayload(pages, pageKeyName, attempt);
			copyNotesData = { ...copyNotesData, pages: finalPayLoad, completionPercent: Number(copyNotesData.completionPercent), _id: content.content_Id };
			contentService
				.save(content._id + 'note', 'studymaterial', copyNotesData, false).
				then((response: any) => {
					const res = response.responseObject || {}
					if (res.draftId) {
						this.props.setDraftId(res.draftId)
					}
				})
		}
	}

	saveContent = () => {
	   this.props.saveContent(false);
	}
	handleClick(direction: string) {
		this.props.handleArrowClick(direction);
	}
	handleFeedback() {
		this.props.addFeedbackActive()
	}
	renderSaveButton() {
		const handleRenderCheck = () => {
			const { formData } = this.props;
			return formData.questionCode === QUESTION_TYPES.PARAGRAPH ? renderSaveButtonForParagraph() : renderSaveButtonForQuestion();
		}
		const renderSaveButtonForQuestion=()=>{
			const {
				isValidAttempts,
				correctAnswer,
				defaultCorrectAnswer,
				alternateAnswer,
				difficultyLevel,
				difficultyType,
				subjects,
				secondarySubjects,
				originalFormData,
				content
			} = this.props;
			const originalDifficultyLevel = content.difficultyLevel;
      		const originalDifficultyType = content.difficultyType;
			const originalSubjects = content.subjects;
			const originalSecondarySubjects = content.secondarySubjects;
			return isValidAttempts && (
				isQuestionAddToQueueModeActive({
				isValidAttempts,
				correctAnswer,
				defaultCorrectAnswer,
				alternateAnswer
			}) || isDifficultyAndSkillAddToQueueModeActive({
				difficultyLevel,
				difficultyType,
				originalDifficultyLevel,
				originalDifficultyType
			}) || isConceptAndChapterAddToQueueModeActive({
				subjects,
				secondarySubjects,
				originalSubjects,
				originalSecondarySubjects
			})
			);
		}
		const renderSaveButtonForParagraph=()=>{
			const { formData, defaultCorrectAnswersForParagraph, isValidAttempts, originalFormData } = this.props;
			const correctAnswerForParagraph: any = formData.content.map((content: any) => {
				content = JSON.parse(JSON.stringify(content))
				if(content.correctAnswer) {
					delete content.correctAnswer._id
					return content.correctAnswer
				}
				return {};
			});
			let alternateAnswerParagraph = false;
			let changeInDifficultySkill = false;
			let changeInConcept = false;
			for (let i = 0; i < formData.content.length; i++) {
				if (formData.content[i].alternateAnswer) {
					alternateAnswerParagraph = true;
					formData.content[i].optionChange = false;
				}
				else{
					formData.content[i].optionChange = !checkIsCorrectAnswerChangeParagraph(defaultCorrectAnswersForParagraph, correctAnswerForParagraph);
				}
				if (originalFormData && originalFormData.content[i]) {
					const originalDifficultyLevel = originalFormData.content[i].difficultyLevel;
					const originalDifficultyType = originalFormData.content[i].difficultyType;
					const originalSubjects = originalFormData.content[i].subjects;
					const originalSecondarySubjects = originalFormData.content[i].secondarySubjects;
					const {
						difficultyLevel,
						difficultyType,
						subjects,
						secondarySubjects,
					} = formData.content[i];
					formData.content[i].conceptChange = isConceptAndChapterAddToQueueModeActive ({
						subjects,
						secondarySubjects,
						originalSubjects,
						originalSecondarySubjects,
					});
					if (formData.content[i].conceptChange) {
						changeInConcept = true;
					}
					formData.content[i].difficultySkillLevelChange=isDifficultyAndSkillAddToQueueModeActive ({
						difficultyLevel,
						difficultyType,
						originalDifficultyLevel,
						originalDifficultyType,
					});
					if(formData.content[i].difficultySkillLevelChange) {
						changeInDifficultySkill = true;
					}
				}
			}
			return formData.questionCode === QUESTION_TYPES.PARAGRAPH &&
				isValidAttempts && 
				( isQuestionAddToQueueModeActiveParagraph({
					isValidAttempts,
					correctAnswer: correctAnswerForParagraph,
					defaultCorrectAnswer: defaultCorrectAnswersForParagraph,
					alternateAnswer: alternateAnswerParagraph
				}) || changeInConcept 
				|| changeInDifficultySkill 
				);
		}
		return (
			<Button
				color="primary"
				variant="outlined"
				// classes={{ root: classes.borderRadius2x }}
				onClick={this.saveContent}
				disabled={handleRenderCheck()}
			>
				Save
			</Button >
		)
	}
	getTitleForNotes() {
        const notesType = _.get(this.props.notesData, 'content.subType', '');

        return OBJECTIVE_NOTES.includes(notesType)||SUBJECTIVE_NOTES.includes(notesType)?"Practice Set":"Study Material";
    }

	getImageUrl(notesType:string)
    {
        const imageUrl=practiceSetTypeImage[notesType]

        return imageUrl ||"/assets/svg/doc-icon.svg";
    }

	getContentBucketName = () => {
		const { content } = this.props;
		const contentSpecialPurpose = CONTENT_SECTION_TYPES.filter(section => (content.specialPurposes || []).includes(section.value));
		return contentSpecialPurpose.length > 0 ? contentSpecialPurpose[0].title : CONTENT_SECTION_TYPES[0].title;
	}

	render() {
		const { classes, content, type, commentCount, requiresForceSaveForChallenge, currentQuestionNumber, currentTestNumber, sliderData, prevPath } = this.props;
		const { isCommentDialogOpen, isForceSaveForChallengeDialogOpen } = this.state;

		const notesType=_.get(this.props.notesData,'content.subType','');

		return (
			<>
				{!this.props.fromFeedback ? (
					<div className={classes.toolBox}>
						<Grid container alignItems="center">
							<Grid item xs={7}>
								<Grid className={classes.displayFlex}>
									<Button
										onClick={this.handleCloseWithPrevention}
										className={classes.closeIcon}
									>
										<CloseIcon />
										{/* {content.masterVariationQuestionId ? 'Back to Master' : 'Close'} */}
									</Button>
									<Grid className={classes.displayFlex}>
										<span>
											<img className={classes.noteIcon} src={this.getImageUrl(notesType)} alt='Note' />
										</span>
										<span>
											{content.contentId} {[AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION, AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS].includes(content.contentTypeCode) && ('| ' + this.getContentBucketName())} | Create Content - Create {type === 'studymaterial' ? this.getTitleForNotes() : _.upperFirst(type)} {content.contentTypeCode === 'question' && `(${QUESTION_TYPE[content.contentSubTypeCode.toString()]})`}
										</span>
									</Grid>
									{!content.masterVariationQuestionId && content.status === 'PUBLISHED' && content.contentTypeCode === 'question' &&
										(
											<Grid className={classes.variationContainer}>
												<Variation content={content} />
											</Grid>
										)
									}
								</Grid>
							</Grid>

							<Grid item xs={5}>
								<div className={classes.actionContainer}>
									{
										// content._id && (
										// 	<IconButton color="default" className={classes.commentButton}
										// 		style={{ padding: '8px 8px 0 8px' }}
										// 		onClick={() => this.setState({ isCommentDialogOpen: true })}
										// 	>
										// 		<Badge badgeContent={commentCount} color="secondary">
										// 			<img src="/assets/svg/createContent/comment.svg" style={{ width: 22 }} />
										// 		</Badge>
										// 	</IconButton>
										// ) commenting for future use
									}
									{
										<div>
											<Typography
												variant="caption"
												align="right"
												color="textSecondary"
											>
												Saved {dateService.timeSince(content.updatedAt)}
											</Typography>
										</div>
									}

									{content._id && (
										<>
											{content.contentTypeCode !== CONTENT_TYPE.QUESTION && <Button variant="outlined" onClick={this.createClone} >
												<span>
													<img src="/assets/svg/createContent/duplicate.svg" />
												</span>{" "}
												Duplicate
											</Button>}

											<Button
												variant="outlined"
												onClick={this.handlePreview.bind(this)}
											>
												<PreviewIcon /> Preview
											</Button>
										</>
									)}
									{this.renderSaveButton()}
								</div>


							</Grid>
						</Grid>
						<Grid container className={classes.toolbarContainer}>
							<Grid item xs={7} id="box">
								{/* Editor toolbar will be loaded here */}
							</Grid>
						</Grid>
					</div>
				) : (
						<div className={classes.toolBox}>
							<Grid
								container
								alignItems="center"
								spacing={16}
								justify="space-between"
							>
								{content._id && (
									<>
										<Grid item>
											<Grid
												container
												justify="space-between"
												alignItems="center"
												onClick={() =>
													this.props.setFeedbackClose({ booleanValue: true })
												}
											>
												<Grid item>
													<MyPATLink
														to={this.props.prevPath}
														className="closeButton"
													>
														<CloseIcon />
														&nbsp;Close
                        </MyPATLink>
												</Grid>
											</Grid>
										</Grid>
										<Grid item>
											<Grid
												container
												justify="flex-end"
												spacing={8}
												alignItems="center"
											>
												<Grid item>
													{content.contentTypeCode !== "testpapers" && (
														<>
															<span>
																{currentQuestionNumber}/
                              {sliderData &&
																	sliderData.contents &&
																	sliderData.contents.length}{" "}
																Question
                            </span>
															<span
																onClick={() => this.handleClick("prev")}
																className={
																	currentQuestionNumber === 1
																		? [classes.deactiveArrow, "arrow"].join(
																			" "
																		)
																		: [classes.activeArrow, "arrow"].join(" ")
																}
															>
																<ChevronLeftIcon />
															</span>
															<span
																onClick={() => this.handleClick("next")}
																className={
																	currentQuestionNumber ===
																		(sliderData &&
																			sliderData.contents &&
																			sliderData.contents.length)
																		? [classes.deactiveArrow, "arrow"].join(
																			" "
																		)
																		: [classes.activeArrow, "arrow"].join(" ")
																}
															>
																<ChevronRightIcon />
															</span>
														</>
													)}
													{content.contentTypeCode === "testpapers" && (
														<>
															<span>
																{currentTestNumber}/
                              {sliderData &&
																	sliderData.contents &&
																	sliderData.contents.length}{" "}
																Test
                            </span>
															<span
																onClick={() => this.handleClick("prev")}
																className={
																	currentTestNumber === 1
																		? [classes.deactiveArrow, "arrow"].join(
																			" "
																		)
																		: [classes.activeArrow, "arrow"].join(" ")
																}
															>
																<ChevronLeftIcon />
															</span>
															<span
																onClick={() => this.handleClick("next")}
																className={
																	currentTestNumber ===
																		(sliderData &&
																			sliderData.contents &&
																			sliderData.contents.length)
																		? [classes.deactiveArrow, "arrow"].join(
																			" "
																		)
																		: [classes.activeArrow, "arrow"].join(" ")
																}
															>
																<ChevronRightIcon />
															</span>
														</>
													)}
												</Grid>
												<Grid item>
													<Button
														variant="outlined"
														onClick={() => this.previewFromFeedback()}
													>
														<PreviewIcon /> Preview
                        </Button>
												</Grid>
												<Grid item>
													<Button
														variant="outlined"
														color="primary"
														onClick={() => this.handleFeedback()}
														disabled={
															!ACLService.checkModulePermission(
																content.contentTypeCode,
																"validate"
															)
														}
													>
														<img
															src="/assets/svg/contentRequest/feedback-trans.svg"
															alt="feedback"
														/>
														&nbsp;<span>Add Feedback</span>
													</Button>
													<CustomInfoIcon
														infoDialogContentType="Add Feedback"
														isCenterArrow={true}
														isRightArrow={false}
														isInfoIcon={true}
														knowMoreAbout={false}
														dialogTitle="Add Feedback"
														imageURL="/assets/svg/contentRequest/feedbackIcon.svg"
														dialogPara="After clicking over this button, you can add feedback over each section of the question. You can click over headings to seek space for adding feedback."
														details="Click to know more"
														toolTipDirection="top"
													/>
												</Grid>
												<Grid item>{this.renderSaveButton()}</Grid>
											</Grid>
										</Grid>
									</>
								)}
							</Grid>
						</div>
					)}
				{isCommentDialogOpen && (
					<CommentDialog
						isDialogOpen={isCommentDialogOpen}
						content={content}
						dialogCloseHandler={this.handleCommentDialogClose.bind(this)}
					/>
				)}
				{isForceSaveForChallengeDialogOpen && (
					<ForceSaveForChallengePopup
						handleClose={() =>
							this.setState({ isForceSaveForChallengeDialogOpen: false })
						}
						handleViewChallenges={this.handleViewChallenges}
					/>
				)}
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	commentList: _.get(state, 'mylibraryData.comment.list', []),
	commentCount: _.get(state, 'mylibraryData.comment.count', 0),
	lockData: _.get(state, 'mylibraryData.content.lockData', {}),
	requiresForceSaveForChallenge: _.get(state, 'mylibraryData.content.requiresForceSaveForChallenge'),
	// all question content state 
	title: state.questionCreate.title,
	optionsContent: state.questionCreate.optionsContent,
	matrixOptionContent: state.questionCreate.matrixOptionContent,
	correctAnswer: state.questionCreate.correctAnswer,
	solutionContent: state.questionCreate.solutionContent,
	stepWiseSolution: state.questionCreate.stepWiseSolution,
	questionHints: state.questionCreate.questionHints,
	subjects: state.questionCreate.subjects,
	secondarySubjects: state.questionCreate.secondarySubjects,
	difficultyLevel: state.questionCreate.difficultyLevel,
	difficultyType: state.questionCreate.difficultyType,
	relevantExams: state.questionCreate.relevantExams,
	tags: state.questionCreate.tags,
	defaultCorrectAnswer: state.questionCreate.defaultCorrectAnswer,
	validations: state.questionCreate.validations,
	alternateAnswer: state.questionCreate.alternateAnswer,
	isValidAttempts: state.questionCreate.isValidAttempts,
	questionBenchmarks: state.questionCreate.questionBenchmarks.benchmarks,
	idealTime: state.questionCreate.idealTime,
	allQuestionBenchmarks: state.questionCreate.questionBenchmarks,
	contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		getCommentCount,
		fetchEditLockInfo: contentActions.fetchEditLockInfo,
		updateQuestionBenchmarks: contentActions.updateQuestionBenchmarks,
		showMsg: showMsg,
		templateChanged: contentActions.templateChanged,
		setRequiresForceSaveForChallenge: contentActions.setRequiresForceSaveForChallenge,
		setIsComingFrom: contentRequestAccordianActions.setIsComingFrom,
		setFeedbackClose: contentRequestAccordianActions.setFeedbackClose,
		setPublishedContent: questionActions.setPublishedContent,
	},
	dispatch
);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HeaderTool));